import { render } from "./ModalLoginError.vue?vue&type=template&id=e3a847d6"
import script from "./ModalLoginError.vue?vue&type=script&lang=js"
export * from "./ModalLoginError.vue?vue&type=script&lang=js"

import "./ModalLoginError.vue?vue&type=style&index=0&id=e3a847d6&lang=scss"

import exportComponent from "/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__